import React from "react";
import ReactTooltip from "react-tooltip";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import { Box, Button } from "@material-ui/core";
import { useStyles } from "./styles";

function UploadButton({
  classes: { borderRadius, capitalize, marginLeft },
  documentTypeId,
  item,
  slug,
  text,
  tooltip,
  uploadClickHandler,
}) {
  return item.documents && !item.documents[documentTypeId] ? (
    <Box>
      <Button
        variant="contained"
        color="secondary"
        size={"small"}
        className={`${borderRadius} ${marginLeft} ${capitalize}`}
        onClick={() => uploadClickHandler(item?.id, slug)}
        data-tip={tooltip}
      >
        <AddCircleOutlineIcon style={{ margin: "3px 6px" }} />
        {text}
      </Button>
      <ReactTooltip html={true} />
    </Box>
  ) : (
    ""
  );
}

export default withStyles(useStyles, { withTheme: true })(UploadButton);
